import React from 'react'
import {Box,Typography} from "@mui/material"
import FilterNavbar from './FilterNavbar'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useEffect, useState } from 'react';
import FiltersBreadCrumbs from './FiltersBreadCrumbs';
import { LandingPageCards } from '../LandingPage1/LandingPageCards/LandingPageCards';
import AllMenuFilter from "./AllMenuFilter";
import CateringCards from '../AllMenu/CateringCards';
import DiscountFooterSection from '../DiscountFooterSection/DiscountFooterSection';
import Footer from '../Footer/Footer';

const Filter = () => {

  return (
    <Box>
        <Box>
            <FilterNavbar/>
        </Box>
        <Box sx={{mt:'50px'}}>
            <Box sx={{margin:"20px"}}>
                <Box sx={{margin:'10px'}}>
                    <FiltersBreadCrumbs/>
                </Box>
            <Box>
                <Typography sx={{
                    fontWeight:600,
                    fontSize:'50px'
                }}>
                    American cuisines in <span style={{color:'#2B817B'}}>Edmonton</span>
                </Typography>
                <Typography sx={{
                    fontWeight:600,
                    fontSize:'35px'
                }}>
                    Top American meal plans
                </Typography>
            </Box>
            <Box sx={{
                mt:'40px', 
                padding:'5px',
            }}>
                <Box>
                    <LandingPageCards/>
                </Box>
            </Box>
            <Box>
                <AllMenuFilter/>
            </Box>
            <Box sx={{mt:'100px'}}>
                <CateringCards/>
            </Box>
            <Box sx={{mt:'100px'}}>
                <DiscountFooterSection/>
            </Box>
            </Box>
            <Box sx={{mt:'70px'}}>
                <Footer/>
            </Box>
        </Box>
    </Box>
  )
}

export default Filter
